<template>
    <div class="info-wrap agreement-info">
        <h2>Agreement</h2>
        <p>Please read the agreements for the plans you enrolled in.</p>
        <div class="agreement-text" v-for="(text, index) in texts" :key="index">
            <h3 v-if="text.title">{{ text.title }}</h3>
            <!-- Body is sanitized by the API (MemberReviewAgreementService::sanitize). -->
            <div class="agreement-body" v-html="text.body"></div>
        </div>
        <div class="row justify-content-end mt-3">
            <div class="col-xxl-3 col-xl-3 col-lg-3 col-md-6">
                <review-next-note action="Next" />
                <button type="button" class="univ-btn" style=" max-width: 100% !important;" @click="$emit('next')">Next</button>
            </div>
        </div>
    </div>
</template>

<script>
import ReviewNextNote from './ReviewNextNote.vue';

export default {
    name: 'AgreementInfo',
    components: { ReviewNextNote },
    props: {
        texts: {
            type: Array,
            required: true,
        },
    },
};
</script>
